import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { map, Observable, take } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { nvlArr, nvlBool, nvlNull, nvlObj } from 'src/app/core/services/utils.service';

@Injectable()
export class AuthGuard implements CanActivate {


  public pwdChangeRequired: boolean = true;

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    return this.authService.isLoggedIn.pipe(
      take(1),
      map((isLoggedIn: boolean) => {

        if (!isLoggedIn) {
          this.router.navigate(['/login']);
          return false;
        }

        const lsUser: any = localStorage.getItem('userInfo');
        const selectedUser: any = lsUser ? JSON.parse(lsUser) : {};
        if (this.pwdChangeRequired && nvlBool(selectedUser.pwdChangeRequired) == 1) {
          this.pwdChangeRequired = false;
          this.router.navigate(['/pwd-change-required']);
          return false;
        }
        this.pwdChangeRequired = true;
        return true;
      })
    )
  }


  public routeValidation(stateUrl: any) {
    const localItem: any = localStorage.getItem("routeList");
    const routeList: any = nvlObj(JSON.parse(localItem)).routes;

    const url = nvlNull(stateUrl.split(';')[0]);
    const isOk = nvlArr(routeList).find((elm: any) => { return elm.routeUrl === url });
    if (isOk) {
      return true;
    }
    return false;
  }

}

